const B_1 = [
    {
        title: '中标结果通知书',
        path: '/bidding/projectflow/dingbiao/zbjgtzs/list'
    }
]
export default {
    path: 'zbjgtzs',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-dingbiao-zhongbiaogg-jsgc'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ding/zbjgtzs/list'),
            meta: {
                title: '中标结果通知书列表',
                bread: '/bidding/projectflow/dingbiao/zbjgtzs/list'
            },
        },
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/ding/zbjgtzs/form'),
            meta: {
                title: '添加中标结果通知书',
                bread: '/bidding/projectflow/dingbiao/zbjgtzs/form'
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ding/zbjgtzs/detail'),
            meta: {
                title: '查看中标结果通知书',
                bread: '/bidding/projectflow/dingbiao/zbjgtzs/detail'
            },
        },
        {
            path:"signatureList",
            component: () => import('@views/bidding/views/project-flow/ding/zbjgtzs/signature/list'),
            meta: {
                title: '签章列表',
                bread: '/bidding/projectflow/dingbiao/zbjgtzs/signature/list'
            },
        },
        {
            path:"signatureForm",
            component: () => import('@views/bidding/views/project-flow/ding/zbjgtzs/signature/form'),
            meta: {
                title: '在线签章',
                bread: '/bidding/projectflow/dingbiao/zbjgtzs/signature/form'
            },
        },
        {
            path:"signatureDetail",
            component: () => import('@views/bidding/views/project-flow/ding/zbjgtzs/signature/detail'),
            meta: {
                title: '签章详情',
                bread: '/bidding/projectflow/dingbiao/zbjgtzs/signature/detail'
            },
        },
    ]
}